export const NAV_CATEGORIES = [
  { slug: "fintech", label: "Fintech" },
  { slug: "payments", label: "Payments" },
  { slug: "banking", label: "Banking" },
  { slug: "cards", label: "Cards" },
  { slug: "infrastructure", label: "Infrastructure" },
  { slug: "digital-assets", label: "Digital Assets" },
  { slug: "regulation", label: "Regulation" },
];

export const CATEGORY_LABELS = {
  fintech: "Fintech", payments: "Payments", banking: "Banking", cards: "Cards",
  infrastructure: "Infrastructure", "digital-assets": "Digital Assets",
  regulation: "Regulation", companies: "Companies", insights: "Insights",
};

export function catLabel(slug) {
  return CATEGORY_LABELS[slug] || (slug || "").replace(/-/g, " ");
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function fullDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric", month: "long", year: "numeric",
  });
}

export function articleHref(a) {
  return `/${a.category}/${a.slug}`;
}
